import { render, staticRenderFns } from "./ZonesTab.vue?vue&type=template&id=68691430&scoped=true&"
import script from "./ZonesTab.vue?vue&type=script&lang=js&"
export * from "./ZonesTab.vue?vue&type=script&lang=js&"
import style0 from "./ZonesTab.vue?vue&type=style&index=0&id=68691430&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68691430",
  null
  
)

export default component.exports